import { useMutation, useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import { markProjectIqWorkspaceUpdated } from "redux/projectIqWorkspacesSlice";
import { createWorkspaceDiagnostic } from "apps/project-iq/api";
import {
  DemographicsPlacement,
  DiagnosticMethod,
  IDiagnostic,
  QuestionBankType,
} from "apps/project-iq/models/IDiagnostic";

export interface ICreateDiagnosticParams {
  name: string;
  description?: string;
  method: DiagnosticMethod;
  questionBankType?: QuestionBankType | null;
  templateId?: string | null;
  background?: string;
  beginningMessage?: string;
  endingMessage?: string;
  headerColor?: string;
  accentColor?: string;
  customBrandingEnabled?: boolean;
  demographicsQuestions?: string[];
  demographicsPlacement?: DemographicsPlacement;
  demographicsQuestionOverrides?: Record<string, string>;
}

export const useCreateDiagnostic = (workspaceId: string) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  return useMutation<IDiagnostic, Error, ICreateDiagnosticParams>(
    (params: ICreateDiagnosticParams) =>
      createWorkspaceDiagnostic({
        workspaceId,
        ...params,
      } as Parameters<typeof createWorkspaceDiagnostic>[0]),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["workspace-diagnostics", workspaceId]);
        dispatch(markProjectIqWorkspaceUpdated(workspaceId));
      },
    },
  );
};
